<script>
export default {
  data() {
    return {
      clientBehaviourButtons: [
        {
          title: 'Multiple items',
          value: 'MULTIPLE_ITEMS'
        },
        {
          title: 'Client obstructions',
          value: 'CLIENT_OBSTRUCTIONS'
        },
        {
          title: 'Loose liner',
          value: 'LOOSE_LINER'
        },
        {
          title: 'Packaged foods',
          value: 'PACKAGED_FOODS'
        },
        {
          title: 'Bin misalignment',
          value: 'BIN_MISALIGNEMENT'
        },
        {
          title: 'Non food items',
          value: 'NON_FOOD_ITEMS'
        },
        {
          title: 'Food outside bin',
          value: 'FOOD_OUTSIDE_BIN'
        }
      ],
      systemButtons: [
        {
          title: 'Too quick',
          value: 'TOO_QUICK'
        },
        {
          title: 'Poor quality',
          value: 'POOR_QUALITY'
        },
        {
          title: 'Lighting',
          value: 'LIGHTING'
        },
        {
          title: 'Steam / Condensation',
          value: 'STEAM_CONDENSATION'
        },
        {
          title: 'Fake: Nothing added',
          value: 'FAKE_NOTHING_ADDED'
        },
        {
          title: 'Bin change / Cleaning',
          value: 'BIN_CHANGE_CLEANING'
        },
        {
          title: 'Bug: Missing photos',
          value: 'BUG_MISSING_PHOTOS'
        }
      ]
    }
  },
  mounted() {
    this.$refs['button-0'][0].focus()
  }
}
</script>

<template>
  <div class="reject-event-container">
    <h3 class="reject-event-title">Why are you rejecting this event?</h3>
    <div class="reject-event-column-container">
      <div class="reject-event-column">
        <div class="reject-event-column-title">Client Behaviour</div>
        <div class="reject-event-colum-content">
          <template v-for="(button, i) in clientBehaviourButtons">
            <button
              :key="button.title"
              class="button button--danger reject-button"
              @click="$emit('selectReason', button.value)"
              :ref="`button-${i}`"
              v-test="{ 'client-reason': i }"
            >
              {{ button.title }}
            </button>
          </template>
        </div>
      </div>
      <div class="reject-event-column">
        <div class="reject-event-column-title">System</div>
        <div class="reject-event-colum-content">
          <template v-for="(button, i) in systemButtons">
            <button
              :key="button.title"
              class="button button--danger reject-button"
              @click="$emit('selectReason', button.value)"
              :ref="`button-${i}`"
              v-test="{ 'system-reason': i }"
            >
              {{ button.title }}
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/styles/_functions.scss';
@import '@/styles/_settings.scss';

.reject-event-container {
  width: 540px;
  padding: 10px 5px 20px 5px;
}

.reject-event-title {
  font-size: $font-size-lg;
  font-weight: $font-weight-bold;
  text-align: center;
  margin-bottom: 20px;
}

.reject-event-column-container {
  display: flex;
}

.reject-event-column {
  flex: 1 1 50%;
  padding: 0 20px;

  &:first-child {
    border-right: 1px solid $gray-500;
  }

  // We're using this trick with overlapping borders in case either of the
  // columns is larger then the other
  &:last-child {
    border-left: 1px solid $gray-500;
    margin-left: -1px;
  }
}

.reject-event-column-title {
  color: $gray-600;
  font-size: $font-size-sm;
  font-weight: $font-weight-bold;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.reject-button {
  display: block;
  width: 100%;

  & + & {
    margin-top: 10px;
  }
}
</style>
